import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../css/documentation2.css';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { useParams } from 'react-router-dom';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import { APP_VERSION } from '../../constants';
import BookCover from '../../components/BookCover';
import ReportBook from '../../components/ReportBook';

const Documentation = () => {
  const [reportData, setReportData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { _id, type } = useParams();
  const token = getToken();
  const companyName = decodeToken(token, 'companyName');
  const companyLogo = decodeToken(token, 'logo');
  const companyBackground = decodeToken(token, 'backgroundImage');

  useEffect(() => {
    const fetchReportData = async () => {
      axios
        .get(`${API_URL}/${ENDPOINTS.SYS}/documentation/${_id}/${type}`, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        })
        .then((response) => {
          console.log(response.data);
          //  console.log('fields:', response.data.fields);
          setReportData(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching user guide data:', error);
          setLoading(false);
        });
    };

    fetchReportData();
  }, []);

  if (loading) {
    return <p>Loading report documentation...</p>;
  }

  if (error) {
    return <p>Error fetching report data: {error}</p>;
  }

  if (Object.keys(reportData).length === 0) {
    return <p>No data available.</p>;
  }

  //console.log('reportData:', reportData);
  return (
    <div className="documentation-container">
      <BookCover
        title={companyName}
        logo={`${API_URL}/${companyLogo}`}
        author="Kaafiye Technology Center"
        version={APP_VERSION}
        description="KAAFI PAY is a comprehensive customer billing and cash management platform designed to streamline invoicing, payment tracking, and financial oversight for businesses and their customers. It includes both admin-facing functionalities and a secure customer portal."
        backgroundImage={`${API_URL}/${companyBackground}`}
      />
      {/* <div className="text-center" style={{ marginTop: '20px' }}>
        <img
          src={`${API_URL}/${companyLogo}`}
          alt={companyName}
          className="rounded-circle"
        />

        <h1 className="title">{companyName}</h1>
        <br />
        <h3>System Documentation</h3>

        <h6>Version: {APP_VERSION}</h6>
        <br />

        <h5>Powered by Kaafiye Technology Center</h5>
      </div> */}
      <ReportBook reportData={reportData} />
    </div>
  );
};

export default Documentation;
